module.exports = __webpack_public_path__ + "img/chartIcon.a514f964.svg";